import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@axilon-apps/libs-ui-shadcn'
import type { Model } from '@axilon-apps/domains-identity/types'

import RenameUserForm from './components/RenameUserForm/RenameUserForm'
import useRenameUser from '../../../../hooks/use-rename-user'

interface Props {
  isOpen: boolean
  close: () => void
  user: Model.User
  showEmail: boolean
}

const RenameUserModal = ({ isOpen, close, user, showEmail }: Props) => {
  const onClose = () => {
    reset()
    close()
  }

  const { submit, fieldErrors, reset, result } = useRenameUser({
    userId: user.id,
    onSuccess: onClose
  })

  return (
    <Dialog open={isOpen} onOpenChange={(next) => !next && onClose()}>
      <DialogContent className="max-h-[90vh] min-w-[600px] overflow-auto">
        <DialogHeader>
          <DialogTitle>Edit user</DialogTitle>
        </DialogHeader>
        <RenameUserForm
          initialValues={{ name: user.name, username: user.username, email: user.email ?? '' }}
          onSubmit={submit}
          onCancel={onClose}
          isLoading={result.isLoading}
          fieldErrors={fieldErrors}
          showEmail={showEmail}
        />
      </DialogContent>
    </Dialog>
  )
}

export default RenameUserModal
